import React, { Component } from "react";
import { connect } from "react-redux";
import ChangeContractType from "../comm/ChangeContractType";
import TableAddressConclude from "../address/TableConclude";
import TableStationConclude from "../station/TableConclude";
import TableAdvancedConclude from "../advanced/TableConclude";
import TableIcregisterConclude from "../icregister/TableConclude";

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contractType: props.contractTab.concludeType || "settled",
    };
  }

  componentWillUnmount() {}

  onChange = e => {
    this.setState({
      contractType: e.target.value,
    });
  };

  render() {
    const { contractType } = this.state;
    const renderTable = () => {
      if (contractType === "oregistapp") {
        return <TableAddressConclude {...this.props} />;
      } if (contractType === "settled") {
        return <TableStationConclude {...this.props} />;
      } if (contractType === "advanced") {
        return <TableAdvancedConclude {...this.props} />;
      } if (contractType === "icregister") {
        return <TableIcregisterConclude {...this.props} />;
      }
    };
    return (
      <div>
        <ChangeContractType
          onChange={this.onChange}
          defaultValue={contractType}
        />
        {renderTable()}
      </div>
    );
  }
}

export default connect(state => ({ contractTab: state.contract_tab }))(Index);



// WEBPACK FOOTER //
// ./src/components/incubator/contract/index/ComConclude.js